import Icon from "components/Activities/Icon";
import _ from "lodash";
import React, { memo } from "react";
import { Link } from "react-router-dom";
import { Create, Delete, Update } from "../Items";
import ActivityItemDom from "./ActivityItemDom";

interface Props {
	activity: tcpinpoint.ActivityItem;
}

const ActivityTemplateItem = ({ activity }: Props) => {
	const props = { key: activity.attributes.item.id, activity };
	let link = `/templates/${_.get(activity.attributes.item.object, "id")}`;
	let output;;
	let icon;

	switch (activity.attributes.item.type) {
		case "Update":
			icon = Icon("update-inspection");
			output = <Update {...props} />;
			break;
		case "Delete":
			icon = Icon("delete-template");
			output = <Delete {...props} />;
			break;
		case "Create":
			icon = Icon("create-template");
			output = <Create {...props} />;
			break;
	}

	return (
		<Link to={link} className="activity-item-link">
			{" "}
			<ActivityItemDom activity={activity} icon={icon} link={link} output={output} />
		</Link>
	);
};

export default memo(ActivityTemplateItem);
